import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iframe"]

  connect() {
    this.element.addEventListener('shown.bs.modal', this.play.bind(this))
    this.element.addEventListener('hide.bs.modal', this.stop.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('shown.bs.modal', this.play.bind(this))
    this.element.removeEventListener('hide.bs.modal', this.stop.bind(this))
  }

  play(event) {
    const button = event.relatedTarget
    const src = button.getAttribute('data-src')
    if (src) {
      this.iframeTarget.src = src + "&autoplay=1"
    }
  }

  stop() {
    const currentSrc = this.iframeTarget.src
    if (currentSrc) {
      const srcWithoutAutoplay = currentSrc.replace("&autoplay=1", "")
      this.iframeTarget.src = srcWithoutAutoplay
    }
  }
}
